import React from "react";

import { useAuth } from "@/hooks/useAuth";
import CardHeaderLabel from "./CardHeaderLabel";

const UserDetailsDockCard = () => {
  const { isAdmin } = useAuth();

  return (
    <div className="flex h-full flex-col gap-4 text-white">
      <CardHeaderLabel label="Profile" className="text-white" />
      <div className="flex flex-1 flex-col gap-4 px-4 pb-4">
        <div className="rounded-lg border border-white/20 bg-white/10 p-4 text-sm">
          <p className="font-semibold">Placeholder profile summary</p>
          <div className="mt-3 space-y-2 text-white/80">
            <div className="flex items-center justify-between">
              <span>Status</span>
              <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs">Active</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Membership</span>
              <span>{isAdmin ? "Admin" : "Member"}</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Last update</span>
              <span>Just now</span>
            </div>
          </div>
        </div>
        <div className="rounded-lg border border-white/20 bg-white/10 p-4 text-sm">
          <p className="font-semibold">Upcoming sections</p>
          <p className="mt-2 text-white/80">
            Preferences, recent activity{isAdmin ? ", and quick admin actions." : ", and saved insights."}
          </p>
        </div>
        <p className="mt-auto text-xs text-white/70">Swipe or click the handle to collapse.</p>
      </div>
    </div>
  );
};

export default UserDetailsDockCard;
